import { getOperationName } from '@apollo/client/utilities';
import { UUID } from '@cmg/common';
import { SnackbarManager } from '@cmg/design-system';
import React from 'react';

import {
  IndicationStatus,
  IndicationStatus as IndicationStatusType,
} from '../../../../../../../../../graphql';
import {
  Calendar_PublishedOfferingsBuySideDocument,
  Calendar_PublishedOfferingsDocument,
} from '../../../../../../../../calendar/components/calendar-grid/graphql/__generated__';
import {
  IndicationActivity_BuySideRouteDocument,
  useIndicationActivity_BuySidePassOnOfferingMutation,
} from '../../../../../graphql/__generated__';

export const refetchQueries = [
  getOperationName(IndicationActivity_BuySideRouteDocument)!,
  getOperationName(Calendar_PublishedOfferingsDocument)!,
  getOperationName(Calendar_PublishedOfferingsBuySideDocument)!,
];

export type usePassOnOfferingParams = {
  offeringId: UUID;
  onClose: () => void;
  indicationStatus?: IndicationStatus | null;
  onFinishEditing?: () => void;
};

export const usePassOnOffering = ({
  offeringId,
  onClose,
  indicationStatus = null,
  onFinishEditing,
}: usePassOnOfferingParams): [() => Promise<void>, boolean] => {
  const [pass, { loading: isPassing }] = useIndicationActivity_BuySidePassOnOfferingMutation();

  const handlePass = React.useCallback(async () => {
    try {
      await pass({
        variables: {
          offeringId,
          activateIfCancelled: indicationStatus === IndicationStatusType.Cancelled,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
      SnackbarManager.success('Successfully passed on offering');
      onClose();
      onFinishEditing?.();
    } catch (e) {
      console.error(e);
      SnackbarManager.error('Failed to pass on offering');
    }
  }, [indicationStatus, offeringId, onClose, onFinishEditing, pass]);

  return [handlePass, isPassing];
};
